export { default } from './FullScreenLoading';
